import { Component, Inject, ViewChild } from "@angular/core";
import { Command, LabelCommand } from "@tylertech/commands-module";
import { DialogRef, DIALOG_DATA } from "@tylertech/forge-angular";
import { ImageCroppedEvent, ImageCropperComponent } from "ngx-image-cropper";

@Component({
    selector: "metadata-photo-crop-dialog",
    templateUrl: "./metadataPhotoCropDialog.tmpl.html",
    standalone: false
})
export class MetadataPhotoCropDialogComponent
{
    @ViewChild("imageCropper") imageCropper: ImageCropperComponent;

    commands: Command[];
    croppedImage: string;

    constructor(
        @Inject(DIALOG_DATA) public data: IDialogData,
        private _dialogRef: DialogRef
    ) {}

    ngOnInit(): void
    {
        const self = this;
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => self.close(),
            }),
            new LabelCommand({
                label: "Done",
                action: () => self.close(true),
            }),
        ];
    }

    close(save = false): void
    {
        this._dialogRef.close(save ? this.croppedImage : null);
    }

    imageCropped(event: ImageCroppedEvent) 
    {
        this.croppedImage = event.base64;
    }
}

export interface IDialogData
{
    photo: string;
}